/*

Geolocation based popup

*/

(function () {
	
	var params = window.location.search;
  
	// GEOIP LOCATIONS   de.lunette.com
	var locationHosts = {
		"FI": "fi.lunette.com",
		"SE": "se.lunette.com",
		"DE": "lunette.com/de",
		"CH": "de.lunette.com",
      	"AT": "de.lunette.com",
      	"AU": "lunette.com.au",
      	"NZ": "lunette.co.nz",
		"US": "store.lunette.com",
		"CA": "store.lunette.com",
		"MX": "store.lunette.com",
		"PT": "pt.lunette.com",
		"UK": "uk.lunette.com",
      	"GB": "uk.lunette.com",
		"BR": "pt.lunette.com",
		"CN": "cn.lunette.com",
		"FR": "lunacopine.fr"
      };

	// LIST OF LUNETTE SITES
	var lunetteDomains = [
     "www.lunette.com", 
      "fi.lunette.com", 
      "se.lunette.com", 
      "lunette.com/de", 
      "store.lunette.com", 
      "lunette.com.au", 
      "lunette.co.nz", 
      "uk.lunette.com", 
      "pt.lunette.com",
      "lunacopine.fr"
    ];

	// MODAL TRANSLATIONS
	var localTranslations = {
		"FI": ["Hei!", "Haluatko tilata tuotteita Suomeen? Siirry suomalaiselle sivustollemme.", "Siirry"],
		"SE": ["Hej!", "Säg hej till din snippas nya bästa vän!", "Klicka här"],
		"DE": ["Hallo!", "Wolltest du hier sein, oder doch lieber auf der deutschen Seite?", "Go"],
		"CH": ["Hallo!", "Wolltest du hier sein, oder doch lieber auf der deutschen Seite?", "Go"],
      	"AT": ["Hallo!", "Wolltest du hier sein, oder doch lieber auf der deutschen Seite?", "Go"],
		"AU": ["G'day!", "What the?! How'd you end up here? Check out our store for the Aussie babes", "Go"],
		"NZ": ["Hello!", "Wandered in to the wops eh? No stress, we've got stores just for the New Zealand babes", "Go"],
		"US": ["Hello!", "You’ve reached our global brand page. Check out our US Store!", "Go"],
		"CA": ["Hello!", "You’ve reached our global brand page. Check out our US Store!", "Go"],
		"MX": ["Hello!", "You’ve reached our global brand page. Check out our US Store!", "Go"],
		"PT": ["Hello!", "We have stores just for you. Head to the Portugal site.", "Go"],
      	"UK": ["Hello!", "Blimey! No need to search so far & wide British lovelies, we have stores just for you.", "Go"],
      	"GB": ["Hello!", "Blimey! No need to search so far & wide British lovelies, we have stores just for you.", "Go"],
      	"FR": ["Hello!", "We have stores just for you. Head to the France site.", "Go"],
		"GLOBAL": ["Hello!", "Where in the world are you? We can help you find the store you need.", "Go"]
	};
  
  	// Country selection menu
  	var lunetteStores = {
      	"US": ["https://store.lunette.com", "North America"],
      	"GB": ["https://uk.lunette.com", "United Kingdom"],
      	"AU": ["https://lunette.com.au", "Australia"],
      	"NZ": ["https://lunette.co.nz", "New Zealand"],
      	"DE": ["https://lunette.com/de", "DE/AUT/CH"],
      	"FR": ["https://lunacopine.fr", "France"],
      	"SE": ["https://se.lunette.com", "Sverige"],
      	"FI": ["https://fi.lunette.com", "Suomi"],
      	"PT": ["https://pt.lunette.com", "Portugal"],
    	"CN": ["https://cn.lunette.com", "中文"],
    	"GLOBAL": ["https://www.lunette.com", "Global (English)"],
  	};
  
	// LOAD GEOIP
	function loadGeoLocation() {
		var access_key = 'fb4bb522b9680673276d5a888cfae36c';

        $.ajax({
            url: 'https://api.ipstack.com/check?access_key=' + access_key,   
            dataType: 'jsonp',
            success: function(json) {

                // output the "capital" object inside "location"
                console.log('COUNTRY CODE IS: ' +json.country_code);
                sessionStorage.setItem("geoLocation", json.country_code);
                checkGeoLocation(json.country_code);

            }
        });
	};


	function checkGeoLocation(country_code) {
      
		var currentLocationCode = country_code;
		var currentDomain = window.location.hostname;
		var globalDomain = "www.lunette.com";

        if((navigator.userAgent.indexOf("Googlebot") || navigator.userAgent.indexOf('google.com')) != -1 ) {
            return;
        }
		if (locationHosts[country_code] === currentDomain) {
			return;
		}

      	$('body').addClass('country-'+country_code);
      
		// IF LOCATION ON THE LIST and NOT IN THE RIGHT DOMAIN
		if (currentLocationCode in locationHosts) {
          	
			openLocalGeoModal(currentLocationCode, localTranslations, locationHosts[country_code]);
			//geoRedirect(currentLocationCode, modalTranslations, locationHosts[country_code], currentDomain);
		} else if (currentDomain !== globalDomain) {
          	
			openGlobalGeoModal(lunetteStores);
			//geoRedirect("GLOBAL", modalTranslations, globalDomain, currentDomain);
		}
	}
	var closeButton = '<button class="CountryPopup__Close" data-action="close-popup" aria-label="Close"><svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14"><path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path></svg></button>';
  
  	function openLocalGeoModal(currentLocationCode, localTranslations, domain){
      	if (typeof localTranslations[currentLocationCode] !== 'undefined' && typeof locationHosts[currentLocationCode] !== 'undefined'){
			$('body').addClass('hide-popup');
      		$('body').append('<div class="country-popup local Modal">'+closeButton+'<h2>'+localTranslations[currentLocationCode][0]+'</h2><p>'+localTranslations[currentLocationCode][1]+'</p><a class="Button Button--primary" href="https://'+locationHosts[currentLocationCode]+params+'">'+localTranslations[currentLocationCode][2]+'</a></div>');
        }
      	
  	}
  
  	function openGlobalGeoModal(lunetteStores){
      	$('body').addClass('hide-popup');
      	var stores = '';
      	for(var code in lunetteStores){
          
          	var store = lunetteStores[code];
            
          	stores += '<li class="'+ code +'"><a class="CountryRedirect" href="'+ store[0] +params+'"><i></i>'+ store[1] +'</a></li>'; 
      	};
      	$('body').append('<div class="country-popup global Modal">'+ closeButton +'<h2>Choose store</h2><ul>'+ stores +'</ul></div>');
  	}
  	
    $(document).on('click', '.CountryPopup__Close', function(){
      	sessionStorage.setItem("nogeoLocation", true);
      	$(this).parents('.country-popup').fadeOut('fast', function(){
        	$(this).remove();
        });
        setTimeout(function() {
         	$('body').removeClass('hide-popup');
        }, 40000);
    });

    $(document).on('click', '.CountryRedirect', function(e){
      	e.preventDefault();
      	sessionStorage.setItem("nogeoLocation", true);
		window.location.href = $(this).attr('href');
    });
  
  	$(document).on('click', '#area-selector-toggle', function () {
		/* $(this).toggleClass('open-areas'); */
      console.log('foobar');
      	if ($('.country-popup.global').length > 0) {
        	$('.country-popup.global').remove();
        } else {
            openGlobalGeoModal(lunetteStores);
        }
      	
	});
  
	function geoRedirect(countryCode, modalTexts, linkTo, currentDomain) {
		// if countryCode is Itävalta AT or Sveitsi CH and site is germany or global no redirect
		if ((countryCode === "AT" || countryCode === "CH") && (currentDomain === "www.lunette.com" || currentDomain === "de.lunette.com")) {}
		// redirect if page is frontpage or collections page
		else if (window.location.href.match(/\/collections/i) || window.location.pathname === "/" || window.location.pathname ==="") {
    		window.location = 'https://' + linkTo;
		}
	};

	var redirect = true;


	// Get previous hostname from document.referrer

	if (document.referrer) {
		url = document.referrer;
		ref = url.match(/:\/\/(.[^/]+)/)[1];

		// check if last hostname is in lunette hostname list and if last page is different than current hostname
		for (var i = 0, j = lunetteDomains.length; i < j; i++) {
			if (ref !== document.location.hostname && ref === lunetteDomains[i]) {
				redirect = false;
				break;
			}
		}
	}
  
    // detect iframe
    function inIframe () {
        try {
        	return window.self !== window.top;
        } catch (e) {
            return true;
        }
	}
  
    if(inIframe()===true){redirect = false;}

	


})();